import React from 'react';
import { Text, View } from 'react-native';
import Icon from '../Icon';
import { Device } from 'DeviceUtils';
import defaultStyles from './EntitlementsModal.jss';

interface CategoriesContainerProps {
    webString: string;
    storeString: string;
    mobileString: string;
}

const CategoriesContainer: React.FC<CategoriesContainerProps> = ({
    webString,
    storeString,
    mobileString
}) => {
    const isTabletOrWeb = Device.isTabletOrWeb;

    const items = [
        { icon: 'globe_icon', text: webString },
        { icon: 'house_icon', text: storeString },
        { icon: 'mobile_icon', text: mobileString }
    ];

    return isTabletOrWeb ? (
        <View style={defaultStyles.constainerTile}>
            {items.map((item, index) => (
                <View key={index} style={defaultStyles.constainerTileTablet}>
                    <Icon
                        name={item.icon}
                        style={{
                            marginBottom: 10,
                            width: item.icon === 'mobile_icon' ? 30 : 60,
                            height: 60
                        }}
                    />
                    <Text style={defaultStyles.suggestionText}>{item.text}</Text>
                </View>
            ))}
        </View>
    ) : (
        <View style={defaultStyles.constainerTile}>
            {items.map((item, index) => (
                <View key={index} style={defaultStyles.rowElement}>
                    <Icon
                        name={item.icon}
                        style={{
                            marginRight: item.icon === 'mobile_icon' ? 20 : 10,
                            width: item.icon === 'mobile_icon' ? 15 : 32,
                            marginLeft: item.icon === 'mobile_icon' ? 8 : 0
                        }}
                    />
                    <Text style={defaultStyles.suggestionText}>{item.text}</Text>
                </View>
            ))}
        </View>
    );
};

export default CategoriesContainer;
